import { render, staticRenderFns } from "./IssueFolio.vue?vue&type=template&id=0aa35ae3&"
import script from "./IssueFolio.vue?vue&type=script&lang=ts&"
export * from "./IssueFolio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports